import { getToken, setToken, removeToken } from '../../utils/auth'
import { login, logout, getInfo } from '../../api/auth'

const state = {
  token: getToken() || '',
  userInfo: {},
  permissions: [],
  menus: []
}

const mutations = {
  SET_TOKEN(state, token) { state.token = token },
  SET_USER_INFO(state, info) { state.userInfo = info },
  SET_PERMISSIONS(state, perms) { state.permissions = perms },
  SET_MENUS(state, menus) { state.menus = menus },
  RESET(state) {
    state.token = ''
    state.userInfo = {}
    state.permissions = []
    state.menus = []
  }
}

const actions = {
  async login({ commit }, credentials) {
    const res = await login(credentials)
    commit('SET_TOKEN', res.data.token)
    setToken(res.data.token)
  },
  async getInfo({ commit }) {
    const res = await getInfo()
    const { permissions, menus, ...userInfo } = res.data
    commit('SET_USER_INFO', userInfo)
    commit('SET_PERMISSIONS', permissions)
    commit('SET_MENUS', menus)
    return res.data
  },
  async logout({ commit }) {
    try { await logout() } catch (e) { /* ignore */ }
    commit('RESET')
    removeToken()
  }
}

export default { namespaced: true, state, mutations, actions }
